import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGetPersonaResponse } from '../../interfaces/response/IGetPersonaResponse';
import { first, map } from 'rxjs/operators';
import { IPartner } from 'src/app/state/user/user.models';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';
import { IClientContract } from '../../interfaces/shared/bundle/IClientContract';

export interface IPersonaByMailResponse {
  idCliente: number;
  entidad: number;
  gestionCliente: number;
  idPersona: number;
}

export interface ICreatePersonaBody {
  nombre: string;
  apellido1: string;
  apellido2?: string;
  sexo?: number;
  fechaNacimiento?: Date;
  idioma: number;
  profesion?: number;
  estadoCivil?: number;
  accesoAplicacion: boolean;
  aspnet_User?: string;
  b2CAccount?: string;
  aDAccount?: string;
  email: string;
  numDocumento: string;
  credencialesEnviadas: boolean;
}

// tiene mas propiedades pero solo nos interesa esta por el momento
export interface ICreatePersonaResponse {
  persona: { idPersona: number };
}

export interface ICreatePersonaPagoBody {
  entidad: number;
  idPersona: number;
  gestionCliente: number;
}

// tiene mas propiedades pero solo nos interesa esta por el momento
export interface ICreatePersonaPagoResponse {
  cliente: { idCliente: number };
}

export interface IGetPersonaPagosResponse {
  idPersonaPago: number;
  defecto: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PersonaService {
  baseUrl = `${environment.baseUrl}`;
  apiUrl = `${environment.ApiPerson}`;
  url: string;

  constructor(private http: HttpClient) {
    this.url = this.baseUrl + this.apiUrl;
  }

  getPersona() {
    return this.http
      .get<IGetPersonaResponse>(`${this.url}/GetData`)
      .pipe(map((resp) => resp.data));
  }

  getDomicilioPersona() {
    return this.http.get<any>(`${this.url}/GetAddress`);
  }

  setDomicilioPersona(idPersona: number, user): Observable<any> {
    const domicilio = {
      idPersona: idPersona,
      provincia: user.provincia?.code || null,
      nombreProvincia: user.provincia?.name || '',

      idMunicipio: user.municipio?.code || null,
      nombreMunicipio: user.municipio?.name || '',

      idCalle: user.calle?.code || null,
      nombreCalle: user.calle?.oldname || user?.nombreVia || '',
      tipoVia: user.calle?.type || '',

      nombreTipoVia: user.calle?.type || '',
      idTipoVia: null,
      nombreVia: user.calle?.name || user?.nombreVia || '',
      complementoVia: null,
      numeroCalle: user.numero?.number || null,

      idCatastro: user.vivienda?.cadastralCode || null,
      piso: user.vivienda?.floor || '',
      puerta: user.vivienda?.door || '',
      portal: user.vivienda?.portal || null,
      escalera: user.vivienda?.stair || '',
      urbanizacion: null,
      codigoPostal:
        user.detalle?.plot?.location?.postalCode ||
        user?.cp ||
        user?.codigoPostal,
      localidad: null,
      codigoPais: 53,
    };
    return this.http.post<any>(`${this.url}/SetAddress`, domicilio);
    // return this.http.post<any>(`${this.url}/Domicilio/persona`, domicilio);
  }

  linkDomicilioPersona(idDomicilio: number): Observable<any> {
    const body = {
      idDomicilio: idDomicilio,
      indPpalOrden: 0,
    };
    return this.http.post<any>(`${this.url}/LinkAddress`, body);
    //return this.http.post<any>(`${this.url}/Domicilio/personaDomicilio`, body);
  }

  setPersona(data): Observable<any> {

    const body = {
      id: data?.id,
      nombre: data?.nombre,
      Apellido1: data?.Apellido1,
      Apellido2: '',
      NumDocumento: data?.NumDocumento,
      CredencialesEnviadas: true,
      Idioma: 1,
    };

    return this.http.post<any>(`${this.url}/SetData`, body);
  }

  createCliente(body: ICreatePersonaPagoBody) {
    return this.http.post<IHttpResponse<ICreatePersonaPagoResponse>>(
      `${this.url}/SetCustomerPayment`,
      body
    );
  }

  createPersona(body: ICreatePersonaBody) {
    return this.http.post<IHttpResponse<ICreatePersonaResponse>>(
      `${this.url}/CreateCustomer`,
      body
    );
  }

  setTelefono(idPersona: number, numTelefono: string): Observable<any> {
    const body = {
      idPersona: idPersona,
      tipoTelefono: null,
      codArea: '34',
      numTelefono: numTelefono,
    };

    return this.http.post<any>(`${this.url}/SetPhone`, body);
  }

  getIdPersonaByDocumento(documento): Observable<any> {
    return this.http.get<any>(`${this.url}/GetIdPersonByDocument/${documento}`);
  }

  getPartnerInfo(idEntidad: number, proxy: boolean = false): Observable<any> {
    let url = `${this.url}/GetPartnerInfo/${idEntidad}`;
    //if(proxy) url = `${environment.proxy.root}/${environment.proxy.api}/${this.apiUrl}/Entidad/${idEntidad}`;
    return this.http.get<IPartner>(url).pipe(first());
  }

  getClienteByEmail(
    email: string
  ): Observable<IHttpResponse<IPersonaByMailResponse[]>> {
    return this.http
      .get<IHttpResponse<IPersonaByMailResponse[]>>(
        `${this.url}/GetCustomerbyEmail/${email}`
      )
      .pipe(first());
  }

  getEntidadByEmail(
    email: string
  ): Observable<IHttpResponse<IPersonaByMailResponse>> {
    return this.http
      .get<IHttpResponse<IPersonaByMailResponse>>(
        `${this.url}/GetEntitybyEmail/${email}`
      )
      .pipe(first());
  }

  getPersonaPagos(idPersona: number) {
    return this.http.get<IHttpResponse<IGetPersonaPagosResponse[]>>(
      `${this.url}/GetPersonPayments/${idPersona}`
    );
  }

  get_persona_by_email(email: string) {
    return this.http.get<IHttpResponse<any>>(
      `${this.url}/GetPersonbyEmail/${email}`
    );
  }

  /**
   * Este endpoint busca en la tabla persona por el OID del token de azure, a través del idPersona, busca en la tabla entidad para traer los datos de la entidad.
   * Devuelve idPartner e idEntidad en caso de encontrarlos en partner, sino devuelve solo el idEntidad, junto a otros datos.
   */
  getPersonAndPartnerByTokenOID(OID: string){
    return this.http.get<IHttpResponse<any>>(
      `${this.url}/getPersonAndPartnerByTokenOID/${OID}`
    );
  }

  getPersonByDocument(document: string) {
    return this.http.get<IHttpResponse<IClientContract>>(`${this.url}/getPersonByDocument/${document}`);      
  }
}
